<template>
  <div class="loading-container">
    <b-loading :is-full-page="true" v-model="isLoading" />
    <div>
      <p>{{ errorMessage }}</p>
    </div>
  </div>
</template>
<style lang="css">
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>
<script>
export default {
  name: "StripePaymentStatusRedirect",
  data() {
    return {
      isLoading: true,
      errorMessage: null,
    };
  },
  mounted() {
    const payment_intent_client_secret =
      this.$route.query.payment_intent_client_secret;

    this.checkPayment(payment_intent_client_secret);
  },
  methods: {
    async checkPayment(client_secret) {
      await this.$stripe.retrievePaymentIntent(client_secret).then((result) => {
        if (result.error) {
          if (result.error.type == "card_error") {
            this.errorMessage = this.error.message;
          } else {
            this.errorMessage = "Error: " + result.error.type;
          }
          console.error(result.error);
        } else {
          const { status, last_payment_error } = result.paymentIntent;

          if (status == "succeeded") {
            sessionStorage.removeItem("uuid_stripe_payment");

            this.$store.dispatch("payment/setStripePaymentSucceeded", true);
            this.$store.dispatch(
              "payment/setStripeActivePage",
              "completePayment"
            );
          } else if (last_payment_error) {
            let error_message = null;
            try {
              error_message = this.$t(
                "stripe_error_messages." + last_payment_error.code
              );
            } catch (err) {
              //skip error logging
            }

            if (error_message && typeof error_message == "string") {
              this.errorMessage = error_message;
            }
          }
        }

        // Safari için sessionStorage'dan parametreleri geri yükle
        let finalQuery = {
          ...this.$route.query,
          error_message: this.errorMessage,
        };

        try {
          const savedParams = sessionStorage.getItem("stripe_redirect_params");
          if (savedParams) {
            const parsedParams = JSON.parse(savedParams);
            // Mevcut query parametreleriyle birleştir (mevcut olanlar öncelikli)
            finalQuery = { ...parsedParams, ...finalQuery };
            // Kullanıldıktan sonra temizle
            sessionStorage.removeItem("stripe_redirect_params");
          }
        } catch (error) {
          console.error("sessionStorage error:", error);
        }

        this.$router.replace({
          path: "/payment/completed",
          query: finalQuery,
        });
      });
    },
  },
};
</script>
